import config from '@config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc);

export const allowedRoutes = ['not-found', 'maintenance'];
export const restrictedRoutes = ['popup-new-organizer','popup-speakers','o','interactions'];
function checkLogin({ resolve, reject }) {
  if (localStorage.getItem('lg')) {
    resolve();
  } else {
    reject();
  }
}
function isEmpty(obj) {
   for (let x in obj) { return false; }
   return true;
}

export default () => [
  // user
  {
    path: '/',
    asyncComponent: () => import('../pages/blank.html')
  },
  // right view
  {
    path: '/interactions/',
    asyncComponent: () => import('../pages/event/chat.html')
  },
  // free access
  {
    path: '/maintenance/',
    asyncComponent: () => import('../pages/maintenance.html')
  },
  {
    path: '/not-found/',
    asyncComponent: () => import('../pages/404.html')
  },
  {
    path: '/server-error/',
    asyncComponent: () => import('../pages/500.html')
  },
  {
    path: '/o/',
    async({to, resolve, reject}) {
      const link = to.params.organizerID;
      if (!app.store.getters.organizers.value[0] || link!=localStorage.getItem('o')) {
        app.store.dispatch("getOrganizers",link).then(() =>  {
          reject();
          app.views.main.router.navigate(`/o/${localStorage.getItem('o')}/`);
        })
      } else {
        reject()
        app.views.main.router.navigate('not-found');
      }
    }
  },

  // popups
  {
    path: '/new-organizer/',
    popup: {
      asyncComponent: () => import('../pages/panel/organizer/popup-new-organizer.html')
    }
  },
  {
    path: '/popup-new-event/',
    popup: {
      asyncComponent: () => import('../pages/panel/organizer/popup-new-event.html')
    }
  },
  {
    path: '/popup-new-stage/',
    popup: {
      asyncComponent: () => import('../pages/panel/event/popup-new-stage.html')
    }
  },
  {
    path: '/popup-select-organizer/',
    popup: {
      asyncComponent: () => import('../pages/panel/organizer/popup-select-organizer.html')
    }
  },

  // panel - organizer
  ...((paths) => {
    return Object.entries(paths).map(([module, path]) => {
      return {
        path,
        async beforeEnter({ to, from, resolve, reject }) {
          const eventID = to.params.eventID;
          const link = to.params.organizerID;
          app.store.state._ACTIVE_ORGANIZER_EVENT_ID = eventID;
          if (!app.store.getters.organizers.value[0] || link!=localStorage.getItem('o')) {
            app.store.dispatch("getOrganizers",link).then(() => resolve());
          } else resolve()
        },
        asyncComponent: () => import(`../pages/panel/organizer/${module}.html`)
      }
    });
  })({
    events: '/o/:organizerID/',
    payments: '/o/:organizerID/payments/',
    sales: '/o/:organizerID/sales/',
    stats: '/o/:organizerID/stats/:eventID/'
  }),
  {
    path: '/o/:organizerID/edit-profile/',
    popup: {
      asyncComponent: () => import('../pages/panel/organizer/edit-profile.html')
    },
    beforeEnter: function ({ to, resolve, reject }) {
      if (!app.store.getters.organizers.value[0] || to.params.organizerID!=localStorage.getItem('o')) {
        app.store.dispatch("getOrganizers",to.params.organizerID).then(() => resolve());
      } else { resolve() }
    }
  },
  {
    path: '/o/:organizerID/brand-verify/',
    asyncComponent: () => import('../pages/panel/organizer/brand-verify.html')
  },
  // panel - event
  ...((paths) => {
    return Object.entries(paths).map(([module, path]) => {
      return {
        path,
        async beforeEnter({ to, from, resolve, reject }) {
          const eventID = to.params.eventID;
          const link = to.params.organizerID;
          app.store.state._ACTIVE_ORGANIZER_EVENT_ID = eventID;
          if (!app.store.getters.organizers.value[0] || link!=localStorage.getItem('o')) {
            app.store.dispatch("getOrganizers",link).then(() => {
              app.store.dispatch("getEventsByOrganizer",link).then(() => resolve());
            });
          } else resolve()
        },
        asyncComponent: () => import(`../pages/panel/event/${module}.html`)
      }
    });
  })({
    general: '/o/:organizerID/e/:eventID/',
    website: '/o/:organizerID/e/:eventID/website/',
    tickets: '/o/:organizerID/e/:eventID/tickets/',
    stage: '/o/:organizerID/e/:eventID/stage/',
    session: '/o/:organizerID/e/:eventID/session/',
    networking: '/o/:organizerID/e/:eventID/networking/',
    expo: '/o/:organizerID/e/:eventID/expo/',
    persons: '/o/:organizerID/e/:eventID/persons/'
  }),
  // player
  ...((paths) => {
    return Object.entries(paths).map(([module, path]) => {
      return {
        path,
        async beforeEnter({ to, from, resolve, reject }) {
          if(!localStorage.getItem('lg')) {
            location.href = `${config.lpUri}/auth/login-redirect?origin=app&redirect=${location.href}`;

            return reject();
          }
          let eventId = parseInt(to.params.eventKey.split('_')[1], 36);
          const checNum = eventId % 10;

          eventId = Math.floor(eventId / 10 ^ 0);

          if (from.path === '/interactions/') {
            return reject();
          }

          if (checksum(String(eventId)) !== checNum) {
            location.href = location.origin + '/not-found/';

            return reject();
          }

          to.params.eventId = eventId;
          to.params.module = module;

          if (!isEmpty(app.store._EVENT)) {
            return resolve();
          }

          try {
            await app.store.dispatch('getEvent', eventId);
            const eventAccess = app.store.getters.event.value.access;
            eventAccess.participant = eventAccess.participant || {};
            const access = !!(eventAccess.participant.is_moderator || eventAccess.participant.is_speaker || eventAccess.organizer || eventAccess.admin);

            if(!access && dayjs.utc().isAfter(dayjs.utc(app.store.state._EVENT.end).add(60,'m'))){
              location.href = `${config.lpUri}/${to.params.organizerId}/${to.params.eventKey}/`;
            }

            if (module === 'backstage') {
              const stg = app.store.state._EVENT.stages;
              const ids = to.params.stageId.split('_');

              to.params.stageId = parseInt(ids[1]);

              if (stg.length > 0 && stg.some(s => s.id == to.params.stageId && s.hash_uri == ids[0])) {
                return resolve();
              }

              app.dialog.alert(_LC.__event_broadcast.noAccess,() => location.href = `${location.origin}/not-found/`);
            } else {
              return resolve()
            }
          } catch (err) {

            if (err.status === 404) {
              location.href = `${location.origin}/not-found/`;

              return reject();
            } else if(err.status === 401) {
              // 401:
              // 1. No auth token - line 156
              // 2. No access:
              app.dialog.alert(_LC.error['401b'],()=>{
                location.href = `${config.lpUri}/events`;
              })
            }
            if (app.params.type==='dev')console.log(err);
            const { code } = JSON.parse(err.response);
            if (app.params.type === 'dev')console.log(code);
            if (code === 3 || code ===4) {
              app.dialog.alert(_LC.error['401b'],()=>location.href = `${config.lpUri}/events`)
            } else if (code === 1) {
              location.href = `${config.lpUri}/auth/login-redirect?origin=app&redirect=${encodeURIComponent(location.href)}`;
            } else {
              console.error(err);

              return reject();
            }
          }
        },
        asyncComponent: () => import('../pages/event/main.html')
      }
    });
  })({
    info: '/:organizerId/:eventKey/info/',
    stage: '/:organizerId/:eventKey/stage/:stageId/',
    session: '/:organizerId/:eventKey/session/:sessionId/',
    networking: '/:organizerId/:eventKey/networking/:networkingId/',
    backstage: '/:organizerId/:eventKey/backstage/:stageId/',
    call: '/:organizerId/:eventKey/call/:callId/:userId/'
  }),
  // others
  {
    path: '(.*)',
    asyncComponent: () => import('../pages/404.html')
  }
];
